export enum JointGiftingApprovalStatus {
  EMPTY = 'EMPTY',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export const enum GiftingMethodEnum {
  DOLLAR_AMOUNT = 'DOLLAR_AMOUNT',
  SHARES = 'SHARES',
}
